import { render, staticRenderFns } from "./clueEdit.vue?vue&type=template&id=b16784ea&scoped=true"
import script from "./clueEdit.vue?vue&type=script&lang=js"
export * from "./clueEdit.vue?vue&type=script&lang=js"
import style0 from "./clueEdit.vue?vue&type=style&index=0&id=b16784ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16784ea",
  null
  
)

export default component.exports